import { extractFormConfiguration } from './extractFormConfiguration';

const extractFlightData = (jsonData) => {
  const data = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;

  const { solutions, price, warnings } = data;
  const transport = solutions[0]?.transport;

  const durationToSeconds = (duration) => {
    const [days, hours, minutes] = duration.split(':').map(Number);
    return days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60;
  };

  const passengersInfo = price.fares.reduce((acc, fare) => {
    const passengerData = {
      quantity: fare.quantity,
      base: fare.base,
      total_taxes: fare.total_taxes,
      fee: fare.fee,
      emission_fee: fare.emission_fee || 0,
      amount: fare.amount,
      total: fare.total,
    };

    switch (fare.passenger_type) {
      case 'ADT':
        acc.adults = passengerData;
        break;
      case 'CHD':
        acc.children = passengerData;
        break;
      case 'INF':
        acc.baby = passengerData;
        break;
    }
    return acc;
  }, {});

  const filteredSupplements = solutions[0]?.supplements
    ?.filter(
      (supplement) => supplement.category === 'HandBaggage' || supplement.category === 'Baggage'
    )
    .map((supplement) => ({
      id: supplement.id,
      short_name: supplement.short_name,
      category: supplement.category,
      included: supplement.included,
      mandatory: supplement.mandatory,
      quantity: supplement.quantity,
      weight: supplement.weight,
      indicator: supplement.indicator,
      pax_references: supplement.pax_references,
      seg_references: supplement.seg_references,
    }));

  const formConfig = extractFormConfiguration(data);

  const filteredWarnings = warnings
    ? warnings.filter((warning) => warning.id === 'CHANGE_PRICE')
    : [];

  const result = {
    token: data.token,
    solution_id: transport.id,
    provider: transport.provider,
    provider_id: transport.provider_id,
    passengers: passengersInfo,
    journeys: {
      outbound: transport.origin_destinations[0].journeys[0]
        ? {
            id: transport.origin_destinations[0].journeys[0].id,
            duration: durationToSeconds(transport.origin_destinations[0].journeys[0].duration),
            departure_date: transport.origin_destinations[0].journeys[0].departure_date,
            segments: transport.origin_destinations[0].journeys[0].segments.map((segment) => ({
              departure_date_time: segment.departure_date_time,
              arrival_date_time: segment.arrival_date_time,
              origin_iata: segment.origin_iata,
              origin_short_name: segment.origin_short_name,
              origin_city_name: segment.origin_city_name,
              destination_iata: segment.destination_iata,
              destination_short_name: segment.destination_short_name,
              destination_city_name: segment.destination_city_name,
              company_name: segment.company_name,
              baggage: segment.baggage,
              baggage_weight: segment.baggage_weight,
              baggage_unit: segment.baggage_unit,
              cabin: segment.cabin,
              marketing_name: segment.marketing_name,
            })),
          }
        : null,
      return: transport.origin_destinations[1]?.journeys[0]
        ? {
            id: transport.origin_destinations[1].journeys[0].id,
            duration: durationToSeconds(transport.origin_destinations[1].journeys[0].duration),
            departure_date: transport.origin_destinations[1].journeys[0].departure_date,
            segments: transport.origin_destinations[1].journeys[0].segments.map((segment) => ({
              departure_date_time: segment.departure_date_time,
              arrival_date_time: segment.arrival_date_time,
              origin_iata: segment.origin_iata,
              origin_short_name: segment.origin_short_name,
              origin_city_name: segment.origin_city_name,
              destination_iata: segment.destination_iata,
              destination_short_name: segment.destination_short_name,
              destination_city_name: segment.destination_city_name,
              company_name: segment.company_name,
              baggage: segment.baggage,
              baggage_weight: segment.baggage_weight,
              baggage_unit: segment.baggage_unit,
              cabin: segment.cabin,
              marketing_name: segment.marketing_name,
            })),
          }
        : null,
    },
    price: {
      currency: price.currency,
      base: price.base,
      total_taxes: price.total_taxes,
      fee: price.fee,
      emission_fee: price.emission_fee,
      total: price.total,
      amount: price.amount,
      fares: price.fares,
    },
    parameters_booking: transport.parameters_booking,
    supplements: filteredSupplements || [],
    formConfiguration: formConfig,
  };

  if (filteredWarnings.length > 0) {
    result.warnings = filteredWarnings;
  }

  return result;
};

export default extractFlightData;
